export enum CartNameSpace {
    ActivitiesHome = 'ActivitiesHome',
}
